module.exports = __webpack_public_path__ + "static/media/raygun.51443d69.svg";